import { withGalleryCardProps } from 'viewModel/gallery/withGalleryCardProps';
import GalleryCard from 'components/Community/GalleryCard/GalleryCard';

export default withGalleryCardProps(GalleryCard);
